var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManaAddressActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60205 7.10356C2.73063 3.96247 5.52067 1.32959 8.04538 0.756067C10.0721 0.296843 11.5436 0.323376 13.1581 1.29081C14.1888 1.90719 15.1827 2.70114 15.8991 3.67673C16.0747 3.91553 16.9788 3.35629 17.2482 3.242C16.54 4.78295 15.1378 8.99352 15.1378 8.99352L9.01282 7.1505C9.01282 7.1505 10.9926 6.63209 11.2457 5.65037C11.5375 4.52578 9.71696 3.22567 8.13519 3.43181C6.20032 3.68489 4.34506 5.31565 2.60205 7.10356C5.3329 3.34201 2.60205 7.10356 2.60205 7.10356Z",
    fill: "url(#paint0_linear_11027_44961)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6441 5.53223C19.3831 7.07726 20.4587 10.7572 19.8219 13.2676C19.3096 15.28 18.6177 16.5781 17.0217 17.5761C16.0032 18.2129 14.8439 18.7395 13.6499 18.9334C13.3581 18.9803 13.4458 20.0396 13.4234 20.3335C12.3743 19.0028 9.25977 15.8372 9.25977 15.8372L13.6846 11.2205C13.6846 11.2205 13.2458 13.2186 14.003 13.8921C14.8725 14.6616 16.8584 13.6329 17.3952 12.1308C18.0544 10.2918 17.4442 7.89774 16.6441 5.53223C18.7524 9.67545 16.6441 5.53223 16.6441 5.53223Z",
    fill: "url(#paint1_linear_11027_44961)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0459 18.5332C8.31297 20.0905 4.60244 19.1231 2.77779 17.2903C1.3144 15.8167 0.55311 14.5553 0.516372 12.6756C0.49188 11.4734 0.63679 10.21 1.08377 9.08546C1.19398 8.80992 0.238796 8.34049 0 8.17313C1.68178 7.95475 5.9944 6.90771 5.9944 6.90771L7.68435 13.0756C7.68435 13.0756 6.19442 11.6734 5.22903 11.9775C4.12077 12.3306 3.98402 14.5594 4.9984 15.7922C6.23728 17.3005 8.60483 18.0046 11.0459 18.5332C6.40872 18.2169 11.0459 18.5332 11.0459 18.5332Z",
    fill: "url(#paint2_linear_11027_44961)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11027_44961",
    x1: 2.60205,
    y1: 5.01462,
    x2: 17.2482,
    y2: 5.01462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11027_44961",
    x1: 9.25977,
    y1: 13.4263,
    x2: 19.9998,
    y2: 13.4263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11027_44961",
    x1: 6.81245e-9,
    y1: 13.5232,
    x2: 11.0459,
    y2: 13.5232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManaAddressActive);
export default __webpack_public_path__ + "static/media/mana-address-active.47510d5039802925419e6dd33675800e.svg";
export { ForwardRef as ReactComponent };